import { Avatar, Box, ButtonBase, Stack, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setSelectedBookingId } from "slices/rentalsReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import useQuery from "utils/router.util";
import ListItem from "./booking-list-item";
import BookingDetailActions from "./booking-detail-actions";
import BookingPolicies from "./booking-policies";
import BookingDocumentsUpload from "./booking-documents-upload";
import BookingDocumentsList from "./booking-documents-list";
import { getConversationId } from "utils/messages.util";
import { ROUTES } from "constants/routes";
import moment from "moment";

const BookingDetails = () => {
  const { rentalsReducer } = useAppSelector((state) => state);
  const { selectedBookingData, list }: any = rentalsReducer;
  const query = useQuery();
  // const dispatch = useAppDispatch();
  const listingOwner: any = selectedBookingData?.user;
  const navigate = useNavigate();
  const [uploadMode, setUploadMode] = useState("");
  const type = query.get("type");

  const getNavigationLink = () => {
    const params = new URLSearchParams({
      ...(type ? { type: type } : {}),
    });

    return `/rental?${params.toString()}`;
  };

  // useEffect(() => {
  //   if (query.get("booking") && list.length > 0) {
  //     dispatch(setSelectedBookingId(Number(query.get("booking"))));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [query, list]);

  if (list.length === 0) {
    return (
      <Box
        sx={{
          mx: "4%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "90%",
          my: "8%",
        }}
      >
        <img src="/assets/img/no-data-cat.png" alt="" width="271px" />
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 700,
            fontSize: "26px",
            lineHeight: "31px",
            mt: "20px",
            mb: "10px",
            textAlign: "center",
          }}
        >
          No{" "}
          {type === "pending"
            ? "Pending"
            : type === "confirmed"
            ? "Confirmed"
            : type === "return"
            ? "Return"
            : "Cancelled"}{" "}
          Bookings Yet!
        </Typography>
        <Typography
          sx={{
            color: "#A2A2A2",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            mb: "15px",
            textAlign: "center",
          }}
        >
          Currently, there are no confirmed bookings in your account. Stay tuned{" "}
          <br />
          for future updates!
        </Typography>
      </Box>
    );
  }
  if (!selectedBookingData) {
    return (
      <Box
        sx={{
          minHeight: "30vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">Booking Details.</Typography>
      </Box>
    );
  }

  const gotoMessaging = async () => {
    const convId = await getConversationId(
      selectedBookingData?.user?.firebase_id,
      selectedBookingData?.user?.name
    );
    if (convId) navigate(ROUTES.MESSAGES.replace(":id", convId ?? "null"));
    else
      navigate(
        `${ROUTES.MESSAGES.replace(":id", "new")}?user=${
          selectedBookingData?.user?.name
        }&fbId=${
          selectedBookingData?.user?.firebase_id
        }&img=${encodeURIComponent(selectedBookingData?.user?.image_url)}`
      );
  };

  if (uploadMode) {
    console.log(uploadMode, "uploadMode");
    return (
      <BookingDocumentsUpload
        uploadMode={uploadMode}
        setUploadMode={setUploadMode}
      />
    );
  }

  return (
    <Box sx={{}}>
      <Typography
        sx={{
          color: "#323232",
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: "35px",

          mb: "10px",
          padding: {
            md: "20px 60px 0 60px",
            lg: "20px 60px 0 60px",
            xl: "20px 60px 0 60px",
            sm: "15px 10px",
            xs: "15px 10px",
          },
          display: {
            sm: "none",
            xs: "none",
            lg: "block",
            xl: "block",
            md: "block",
          },
        }}
      >
        Booking details
      </Typography>
      <Box
        sx={{
          display: {
            sm: "flex",
            xs: "flex",
            lg: "none",
            xl: "none",
            md: "none",
          },
          padding: {
            md: "20px 60px 0 60px",
            lg: "20px 60px 0 60px",
            xl: "20px 60px 0 60px",
            sm: "15px 10px",
            xs: "15px 10px",
          },
          gap: "15px",
          alignItems: "center",
          borderBottom: {
            sm: "1px solid #E2E2E2",
            xs: "1px solid #E2E2E2",
          },
          // position: "fixed",
          // width: "100%",
          background: "#FFF",
          zIndex: 2,
        }}
        onClick={() => navigate(getNavigationLink())}
      >
        <img
          src="/assets/img/icons/arrow_left.svg"
          alt=""
          width="24px"
          height="24px"
        />
        <Typography
          sx={{
            color: "#323232",
            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "31px",
          }}
        >
          Booking details
        </Typography>
      </Box>
      <Box
        sx={{
          my: "15px",
          borderRadius: "10px",
          padding: {
            md: "20px 60px 0 60px",
            lg: "20px 60px 0 60px",
            xl: "20px 60px 0 60px",
            sm: "15px 10px",
            xs: "15px 10px",
          },
          mt: { sm: "0", xs: "0", lg: "0", xl: "0", md: "0" },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <Avatar
              src={listingOwner?.image_url}
              sx={{
                img: { width: "65px", height: "65px" },
                width: "65px",
                height: "65px",
              }}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Typography
                sx={{
                  color: "#323232",
                  fontSize: "18px",
                  fontWeight: 600,
                  lineHeight: "14px",
                }}
              >
                {listingOwner?.name}
              </Typography>
              <Typography
                sx={{
                  color: "#323232",
                  fontSize: "13px",
                  fontWeight: 400,
                  lineHeight: "14px",
                }}
              >
                Joined in {moment(listingOwner?.created_at).format("MMM yyyy")}
              </Typography>
            </Box>
          </Box>
          <ButtonBase
            sx={{
              background: "#307AFF",
              width: {
                md: "160px",
                lg: "160px",
                xl: "160px",
                sm: "48px",
                xs: "48px",
              },
              height: {
                md: "56px",
                lg: "56px",
                xl: "56px",
                sm: "48px",
                xs: "48px",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              color: "#FFF",
              borderRadius: "10px",
            }}
          >
            <Typography
              sx={{
                display: {
                  md: "block",
                  lg: "block",
                  xl: "block",
                  sm: "none",
                  xs: "none",
                },
              }}
              color="#FFF"
              fontSize="15px"
              onClick={gotoMessaging}
            >
              Message Owner
            </Typography>

            <Box
              sx={{
                display: {
                  md: "none",
                  lg: "none",
                  xl: "none",
                  sm: "block",
                  xs: "block",
                },
              }}
              color="#FFF"
              fontSize="15px"
            >
              <img src="/assets/img/icons/message.svg" alt="" />
            </Box>
          </ButtonBase>
        </Box>
        <Box sx={{ my: "15px" }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "30px",
              mb: "10px",
            }}
          >
            Order info
          </Typography>
          <Stack spacing="10px">
            {selectedBookingData?.booking_items?.map(
              (item: any, index: number) => (
                <ListItem
                  data={item}
                  isLast={
                    index + 1 === selectedBookingData?.booking_items?.length
                  }
                  bookingId={selectedBookingData?.id}
                  bData={selectedBookingData}
                />
              )
            )}
          </Stack>
          <BookingDocumentsList />
          <BookingDetailActions setUploadMode={setUploadMode} />
          <BookingPolicies />
        </Box>
      </Box>
    </Box>
  );
};

export default BookingDetails;
